<template>
  <div class="TableBox">
    <div style="margin: 0 0 16px">
      <el-select
        v-model="company"
        @change="init(1)"
        style="width: 150px"
        size="mini"
        clearable
        filterable
        placeholder="签约公司"
      >
        <el-option
          v-for="(item, index) in companyList"
          :key="index"
          :label="item.company"
          :value="item.company"
        />
      </el-select>
      <el-input
        placeholder="请输入客户名称"
        v-model.trim="customer_name"
        clearable
        @keydown.enter.native="init(1)"
        @clear="init(1)"
        size="mini"
        style="width: 200px"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="init(1)"
          style="padding: 0 10px"
        ></el-button>
      </el-input>
      <el-select
        v-model="cost_company_name"
        @change="init(1)"
        style="width: 150px"
        size="mini"
        clearable
        filterable
        placeholder="成本公司全称"
      >
        <el-option
          v-for="(item, index) in costCompanysList"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>
    <div class="operationUploadBox clear" style="margin-top: 5px">
      <div class="operationUpload">
        <div
          class="batchDelete"
          style="background: #d51414; border-color: #d51414"
          @click="batchDelete"
        >
          批量删除
        </div>
        <div
          class="batchDelete"
          style="background: #ff9b3b; border-color: #ff9b3b"
          @click="clearSelection"
        >
          清空选中
        </div>
      </div>
      <div class="refreshIcon batchDelete" @click="init({ page: 1 })">
        刷新
        <i class="el-icon-refresh"></i>
      </div>
      <!-- <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div> -->
    </div>
    <ux-grid
      class="uxGridBox"
      ref="plxTable"
      :height="height"
      :checkboxConfig="{ checkMethod: selectable, highlight: true }"
      @selection-change="selectionChange"
      @table-body-scroll="scroll"
      show-footer-overflow="tooltip"
      show-overflow="tooltip"
      keep-source
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      size="mini"
    >
      <ux-table-column title="实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
        <template v-slot="{ row }">{{ row.order_original_month }}</template>
      </ux-table-column>
      <ux-table-column title="当月实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="130">
        <template v-slot="{ row }">{{ row.original_order_original_month }}</template>
      </ux-table-column>
      <!-- 回款日期、帐期(结算单是否归档)：商务助理专享 -->
      <template v-if="userInfo.role_id == 12 || userInfo.admin_id == 53">
        <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
        <ux-table-column title="回款日期" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
          <template v-slot="{ row }">{{ row.date_of_collection }}</template>
        </ux-table-column>
        <ux-table-column title="结算单是否归档" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="110">
          <template v-slot="{ row }">{{ row.payment_days }}</template>
        </ux-table-column>
      </template>
      <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop"
        :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed" align="center" />
      <!-- <ux-table-column title="状态" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100"
        fixed="right">
        <template v-slot="{ row }">
          <span v-if="row.status < 3">未锁单</span>
          <div v-else>
            <span v-if="row.status == 3 && (row.cost_verify_status == 0 || !row.cost_verify_status)">媒介锁单</span>
            <span v-if="row.status == 4 && (row.cost_verify_status == 0 || !row.cost_verify_status)">财务锁单</span>
            <span v-if="row.cost_verify_status == 1">待媒介审核</span>
            <span v-if="row.cost_verify_status == 2">媒介通过</span>
            <span v-if="row.cost_verify_status == 3">媒介驳回</span>
            <span v-if="row.cost_verify_status == 4">财务通过</span>
            <span v-if="row.cost_verify_status == 5">财务驳回</span>
          </div>
        </template>
      </ux-table-column> -->
    </ux-grid>
    <div class="paginationBox" style="height: 30px;">
      <el-pagination
        small
        background
        :current-page="page"
        :page-size="page_size"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import columnsJson from '../json/total.js'
export default {
  data() {
    return {
      height: 0,
      columns: [], //表头
      scrollTop: 0,
      loading: false,
      multipleSelection: [],
      multipleSelection1: {},
      page: 1,
      page_size: 100,
      total: 0,
      selectionList: [],
      flag: false,

      userInfo: {},
      companyList: [],
      costCompanysList: [],
      company: "",
      customer_name: "",
      cost_company_name: "",
    };
  },
  created() {
    this.getCompany()
    this.costCompanys()
    this.columns = columnsJson.filter((v) => {
      return v.prop != 'change_month'
    })
  },
  mounted() {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.height =
      document.documentElement.clientHeight - 255 > 400
        ? document.documentElement.clientHeight - 255
        : 400;
    this.init({ page: 1 });
  },
  methods: {
    getCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
    costCompanys () {//成本公司全程列表
      this.$axios.get(this.URL.BASEURL + this.URL.costCompanys, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.costCompanysList = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    batchDelete() {
      //批量删除
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: "未选择要删除的订单",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定要删除所选中订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var arr = [];
          this.multipleSelection.forEach((item) => {
            arr.push(item.id);
          });
          this.$loading(this.$loadingConfig);
          this.$axios
            .post(this.URL.BASEURL + this.URL.orderExtra_batchDel, {
              ids: arr,
            })
            .then((res) => {
              var res = res.data;
              if (res && res.errno == 0) {
                this.$message({
                  message: "删除成功！",
                  type: "success",
                });
                this.init({ page: 1 });
              } else {
                this.$loading(this.$loadingConfig).close();
                this.$message({
                  message: res.err,
                  type: "warning",
                });
              }
            })
            .catch(() => {
              this.$loading(this.$loadingConfig).close();
            });
        })
        .catch(() => {});
    },
    uploadSuccess(res, file, fileList) {
      this.$loading(this.$loadingConfig).close();
      if (res.errno == 0) {
        this.$alert("导入成功！", "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          callback: (action) => {
            this.init({ page: 1 });
          },
        });
      } else {
        var errHint = "";
        if (Array.isArray(res.rst.error)) {
          errHint = "<p>有误字段：</p><ul>";
          res.rst.error.forEach((item) => {
            errHint += `<li>第${item.row}行：${item.error.join(",")}</li>`;
          });
          errHint += "</ul>";
        } else {
          errHint = res.rst.error;
        }
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    uploadError(err, file, fileList) {
      this.$loading(this.$loadingConfig).close();
      this.$alert("上传失败", "服务器错误", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        callback: (action) => {},
      });
    },
    uploadProgress() {
      //上传中
      this.$loading(this.$loadingConfig);
    },
    clearSelection() {
      //清空选中
      this.$refs.plxTable.clearSelection();
      this.multipleSelection1 = {};
      this.multipleSelection = [];
      this.selectionList = [];
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.plxTable.toggleRowSelection([
            {
              row: row,
              selected: true,
            },
          ]);
          if (index == rows.length - 1) {
            this.flag = true;
          }
        });
      }
    },
    handleCurrentChange(val) {
      this.init({ page: val, selection: "clear" });
    },
    init({ page, exportFlag, selection }) {
      if (!selection || selection != "clear") {
        this.clearSelection();
      }
      var params = {
        page: page,
        page_size: this.page_size,
        company: this.company,
        customer_name: this.customer_name,
        cost_company_name: this.cost_company_name,
      };
      if (exportFlag) {
        params.page = 1;
        params.page_size = 10000;
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }

      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.orderExtra_recordList, {
          params,
        })
        .then((res) => {
          var res = res.data;
          this.$loading(this.$loadingConfig).close();
          if (res && res.errno == 0) {
            var data = res.rst;
            if (exportFlag) {
              this.$exportOrder({
                source: "offline",
                dataList: data.data,
                name: "二次修改成本返点",
              });
            } else {
              this.total = data.pageInfo.total;
              this.datas = data.data; // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
              this.$refs.plxTable.reloadData(this.datas);
              this.$nextTick(() => {
                if (
                  this.multipleSelection1["page_" + this.page] &&
                  this.multipleSelection1["page_" + this.page].length != 0
                ) {
                  var rows = [],
                    arr = [];
                  this.multipleSelection1["page_" + this.page].forEach(
                    (item) => {
                      arr.push(item.id);
                    }
                  );
                  rows = this.datas.filter((v) => {
                    return arr.indexOf(v.id) != -1;
                  });
                  this.flag = false;
                  this.toggleSelection(rows);
                } else {
                  this.flag = true;
                }
              });
            }
          } else {
            this.$message({
              message: res.err,
              type: "warning",
            });
          }
        })
        .catch(() => {
          this.$loading(this.$loadingConfig).close();
        });
    },
    scroll({ scrollTop, scrollLeft }) {
      this.scrollTop = scrollTop;
    },
    selectable({ row }) {
      //选择表格限制条件
      return true
    },
    selectionChange(row) {
      // 选中的行
      this.selectionList = row;
      if (this.flag) {
        this.multipleSelection1["page_" + this.page] = this.selectionList;
        this.multipleSelection = [];
        for (var i in this.multipleSelection1) {
          this.multipleSelection = this.multipleSelection.concat(
            this.multipleSelection1[i]
          );
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/tableStyle.scss";
.topOperation {
  display: flex;
  align-items: top;
  .screenBox {
    flex: 1;
  }
}
.TableBox {
  padding: 15px;
  background: #fff;
  margin-top: 15px;
}
.operationUpload,
.operationUploadBox {
  display: flex;
  align-items: center;
}
.operationUpload {
  flex: 1;
}
.fileTemplate {
  font-size: 12px;
  margin-right: 10px;
  text-decoration: underline;
  margin: 8px 10px 0 0;
  color: #5b7bfe;
  display: block;
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.uxGridBox {
  margin-top: 15px;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
.common_notice {
  > div {
    line-height: 25px;
    font-size: 14px;
  }
  p {
    color: #333;
    font-size: 16px;
    line-height: 40px;
    font-weight: 700;
  }
  .before {
    font-weight: bold;
  }
}
.common_tooltip {
  cursor: pointer !important;
  line-height: 29px !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  font-size: 13px !important;
  &.el-button:focus,
  &.el-button:hover {
    color: #2662ff !important;
  }
  &:hover {
    background: transparent;
  }
  .common_tooltip_question,
  .common_tooltip_question1 {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    margin-left: 4px;
    margin-top: -3px;
  }
  .common_tooltip_question1 {
    display: none;
  }
  &:hover {
    .common_tooltip_question {
      display: none;
    }
    .common_tooltip_question1 {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/medium/orderExtra.vue